const de = {
    header: {
        title: 'Benachrichtigungen',
        'mark-all-read': 'Alle als gelesen markieren',
    },
    notification: {
        'mark-as-read': 'Als gelesen markieren',
        'mark-as-unread': 'Als ungelesen markieren',
        delete: 'Löschen',
        menu: 'Menu',
    },
    'web-push-notifications': {
        notice: 'Wenn Sie Browser-Benachrichtigungen aktivieren, bleiben Sie noch besser auf dem Laufenden.',
        'enable-now': 'Aktivieren',
    },
    messages: {
        'empty-inbox': "Alles Sauber!<br>Wir melden uns, wenn's was neues gibt!",
    },
    preferences: {
        title: 'Einstellungen',
        toggle: 'Benachrichtigungseinstellungen',
        close: 'Einstellungen schließen',
    },
};
export default de;
//# sourceMappingURL=de.js.map